import confetti from 'canvas-confetti'

export const showPurchaseConfetti = () => {
  if (typeof window === 'undefined') return

  // Fire several waves over ~1.4s for a bigger, longer celebration effect.
  const fire = confetti as unknown as (
    options?: Record<string, unknown>
  ) => Promise<null> | null

  const durationMs = 1000
  const end = Date.now() + durationMs

  const interval = window.setInterval(() => {
    const timeLeft = end - Date.now()
    if (timeLeft <= 0) {
      window.clearInterval(interval)
      return
    }

    const progress = 1 - timeLeft / durationMs
    const particleCount = Math.max(50, Math.floor(160 - progress * 90))
    const startVelocity = 90

    // Left side cannon: starts below viewport and shoots upward/inward.
    void fire({
      particleCount,
      angle: 45,
      spread: 60,
      startVelocity: startVelocity,
      ticks: 300,
      scalar: 1.2,
      origin: { x: -0.05, y: 1.12 },
      zIndex: 2147483647
    })

    // Right side cannon: starts below viewport and shoots upward/inward.
    void fire({
      particleCount,
      angle: 135,
      spread: 60,
      startVelocity: startVelocity,
      ticks: 300,
      scalar: 1.2,
      origin: { x: 1.05, y: 1.12 },
      zIndex: 2147483647
    })
  }, 180)
}
